import React from 'react';
import styles from './style.module.scss';
import Checkbox from '../../../../components/Checkbox/Index';
import Row from './row';
import useMccStore from '../../../../stores/mcc';
import SkeletonRow from '../../../../components/skeleton-loader/table/row';
import rowsToFill from '../../../../utils/rows-to-fill';

const MCC_TABLE_COLUMNS = 7;

const Table = ({
  data,
  fetchData,
  dataLoading = false,
}) => {

  const searchFilters = useMccStore(state => state.searchFilters);
  const setSearchFilters = useMccStore(state => state.setSearchFilters);
  const selectedMcc = useMccStore(state => state.selectedMcc);
  const setSelectedMcc = useMccStore(state => state.setSelectedMcc);

  const onSortClick = (type) => {
    setSearchFilters({
      ...searchFilters,
      sortBy: type,
      sortColumn: searchFilters.sortColumn == 'ASC' ? 'DESC' : 'ASC'
    })
  }

  const onCheckAll = (e) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedMcc(data.map(item => item.id))
    } else {
      setSelectedMcc([])
    }
  }

  return (
    <table className={styles.table} >
      <thead className={styles.tableHead} >
        <tr className={styles.theadRow} >
          <th className={`${styles.th} ${styles.w40px}`} >
            <Checkbox
              checked={data?.length > 0 && selectedMcc.length === data.length}
              onChange={onCheckAll}
              disabled={dataLoading}
            />
          </th>
          <th className={`${styles.th} ${styles.w140px}`} onClick={() => onSortClick('id')} >
            <div className={styles.flex} >
              <span>ID</span>

              {searchFilters?.sortBy == 'id' && (
                <span className={`${searchFilters?.sortBy == 'id' && searchFilters?.sortColumn == 'ASC' ? styles.asc : styles.desc}`} >
                  ↑
                </span>
              )}

            </div>
          </th>
          <th className={`${styles.th} ${styles.w140px}`} onClick={() => onSortClick('mcc')} >
            <div className={styles.flex} >
              <span>MCC</span>
              {searchFilters?.sortBy == 'mcc' && (
                <span className={`${searchFilters?.sortBy == 'mcc' && searchFilters?.sortColumn == 'ASC' ? styles.asc : styles.desc}`} >
                  ↑
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th}`} onClick={() => onSortClick('category')} >
            <div className={styles.flex} >
              <span>Category</span>
              {searchFilters?.sortBy == 'category' && (
                <span className={`${searchFilters?.sortBy == 'category' && searchFilters?.sortColumn == 'ASC' ? styles.asc : styles.desc}`} >
                  ↑
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th}`} onClick={() => onSortClick('description')} >
            <div className={styles.flex} >
              <span>Description</span>
              {searchFilters?.sortBy == 'description' && (
                <span className={`${searchFilters?.sortBy == 'description' && searchFilters?.sortColumn == 'ASC' ? styles.asc : styles.desc}`} >
                  ↑
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th} ${styles.w140px}`} >
            Risk Type
          </th>
          <th className={`${styles.th} ${styles.w40px}`} ></th>
        </tr>
      </thead>

      <tbody className={styles.tableBody} >
        {dataLoading &&
          Array.from({ length: rowsToFill(window.innerHeight, 56) }).map((_, index) => (
            <SkeletonRow key={`skeleton-${index}`} columnLength={MCC_TABLE_COLUMNS} />
          ))}
        {!dataLoading && !data?.length && (
          <tr>
            <td colSpan={MCC_TABLE_COLUMNS}>
              <div className={styles.noData}>No data to display</div>
            </td>
          </tr>
        )}
        {!dataLoading && data.map((item, index) => (
          <Row key={item.id ?? index} data={item} fetchData={fetchData} />
        ))}
      </tbody>
    </table>
  )
}

export default Table